import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'

import App from './App.vue'
import router from './router'
import store from './store'
import api from './api'
import './registerServiceWorker'
import { Api } from './types'

Vue.config.productionTip = false

Vue.use(BootstrapVue)

Vue.prototype.$api = api

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

declare module 'vue/types/vue' {
  interface Vue {
    $api: Api
  }
}
